export const DATE_FORMAT = 'dd MMMM yyyy'
export const AXIOS_TIMEOUT_ERROR = 'TimeoutError'
export const YM_ID = '35148630'
